import { TemplateKind } from '../Model/TemplateKind';
import { WidgetPosition } from '../Model/WidgetPosition';
var ModalManager = /** @class */ (function () {
    function ModalManager(modal) {
        this._modal = null;
        this._modal = modal;
    }
    ModalManager.prototype.show = function (widget, showCb) {
        var content = widget.render(TemplateKind.Modal);
        var params = {
            kind: TemplateKind.Modal,
            position: WidgetPosition.Modal
        };
        if (this.canShow()) {
            this._shown = true;
            this._modal.show(params, content, showCb);
        }
    };
    ModalManager.prototype.hide = function () {
        var params = {
            kind: TemplateKind.Modal,
            position: WidgetPosition.Modal
        };
        this._shown = false;
        this._modal.hide(params);
    };
    ModalManager.prototype.destroy = function () {
        var params = {
            kind: TemplateKind.Modal,
            position: WidgetPosition.Modal
        };
        this._shown = false;
        this._modal.destroy(params);
    };
    ModalManager.prototype.canShow = function () {
        return !this._shown;
    };
    return ModalManager;
}());
export { ModalManager };
